import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=32ea9c1a&scoped=true"
import script from "./Faq.vue?vue&type=script&lang=js"
export * from "./Faq.vue?vue&type=script&lang=js"
import style0 from "./Faq.vue?vue&type=style&index=0&id=32ea9c1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ea9c1a",
  null
  
)

export default component.exports